<template lang="html">
  <div class="favorites-wrapper-background">
    <div class="favorites-wrapper">
      <div v-if="items.length > 0" class="favorites-items-wrapper">
        <item :itemData="item" v-for="item in items" :key="item.pro_id" class="" />
      </div>
      <div v-else class="no-result">
        {{$t('wishList.empty')}}
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/api'
import Item from '@/components/item/item.vue'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'Favorites',
  components: {
    Item
  },
  data () {
    return {
      items: []
    }
  },
  mounted () {
    this.getFavorites()
    eventBus.$on('refresh', () => {
      this.getFavorites()
    })
  },
  methods: {
    getFavorites () {
      api.getFavorites().then(res => {
        this.items = res.data.data
      }).catch(e => {
        console.log(e)
      })
    }
  },
  destroyed () {
    eventBus.$off('refresh')
  }
}
</script>

<style lang="scss" scoped>
.favorites-wrapper-background {
  background: #F2F2F2;
  padding-top: 30px;
  padding-bottom: 60px;
  width: 100%;

  .favorites-wrapper {
    display: flex;
    height: 100%;
    max-width: 1600px;
    width: calc( 100% - 40px );
    margin: 0 auto;
    background: white;
    padding: 40px 40px;
    box-sizing: border-box;

    .favorites-items-wrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .item-wrapper {
        margin-bottom: 30px;
      }
    }
  }
}
</style>
